/// <amd-module name="Build/DesignerExtensions/YamlSnippetForm/Utilities/YamlExport" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { CustomizedTemplateDataProviderRequest, YamlSnippet } from "Pipelines/Common/Library/Contracts/DataProvider";
import { InputTypes } from "Pipelines/Common/Library/Contracts/Constants";
import { TemplateContent } from "Build/DesignerExtensions/YamlAssistantLibrary/Contracts/Types";

const NEWLINE = "\r\n";
const INDENT_2 = "  ";
const INDENT_4 = "    ";
const INDENT_6 = "      ";
const MULTI_LINE_STRING = "|\n"

export async function exportYaml(pageContext: IVssPageContext, snippet: YamlSnippet, userInputs: { [key: string]: string }): Promise<string> {
    return Boolean(snippet.content)
        ? getYamlFromContent(pageContext, snippet, userInputs)
        : createYamlFromInputs(snippet, userInputs);
}

function createYamlFromInputs(snippet: YamlSnippet, userInputs: { [key: string]: string }): string {
    const snippetName = snippet.name + "@" + snippet.version.major;
    let exportString: string = "- task: " + snippetName + NEWLINE;
    if (snippet.inputs.length > 0) {
        exportString += INDENT_2 + "inputs:" + NEWLINE;
    }
    
    snippet.inputs.forEach(snippetInput => {
        let userInput = userInputs[snippetInput.name];

        if (userInput !== undefined) {
            if (snippetInput.type !== InputTypes.BOOL &&
                snippetInput.type !== InputTypes.INT &&
                userInput !== "") {
                    userInput = userInput.trim();
                    if (userInput.indexOf("\n") > 0) {
                        userInput = MULTI_LINE_STRING + userInput;
                        userInput = userInput.split('\n').join(NEWLINE + INDENT_6);
                    }
                    else {
                        userInput = "'" + userInput.replace(/'/g, "''") + "'";
                    }
            }
            const inputKey = (snippetInput.aliases && snippetInput.aliases.length > 0 && snippetInput.aliases[0])
                             || snippetInput.name;
            exportString += INDENT_4 + inputKey + ": " + userInput + NEWLINE;
        }
    });

    return exportString;
}

function getYamlFromContent(pageContext: IVssPageContext, snippet: YamlSnippet, userInputs: { [key: string]: string }): Promise<string> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    const dataProviderId = "ms.vss-build-web.customized-template-data-provider";

    const templateParameters = { ...userInputs, templateId: snippet.id };
    const requestParams: CustomizedTemplateDataProviderRequest = {
        templateParameters,
        validateAssets: false,
        branch: "",
        connectionId: "",
        repositoryId: "",
        sourceProviderType: "",
    };

    return contributionService.getDataAsync<TemplateContent, CustomizedTemplateDataProviderRequest>(dataProviderId, requestParams).then((yaml: TemplateContent) => {
        return (yaml && yaml.content) || "";
    });
}
